import { showToast } from './toast';

/**
 * Link to one technique: <origin>/t/<id>.
 *
 * BASE_URL carries its trailing slash and differs between dev (/gnosis/) and
 * production (/), so build off it rather than hard-coding the path.
 */
export function techniqueShareUrl(id: string): string {
  return `${window.location.origin}${import.meta.env.BASE_URL}t/${id}`;
}

/**
 * Hand the link to the OS share sheet on a phone, or the clipboard everywhere
 * else, and say what happened.
 *
 * The share sheet is its own confirmation; a silent clipboard write isn't, so
 * that path raises a toast. The button itself never changes icon — swapping in
 * a tick makes the control look like it did something different to what it
 * does next time.
 */
export async function shareTechnique(id: string, name: string, preferSheet: boolean): Promise<void> {
  const url = techniqueShareUrl(id);
  if (preferSheet && navigator.share) {
    // A dismissed sheet rejects; that isn't an error worth surfacing.
    try { await navigator.share({ title: name, url }); } catch { /* dismissed */ }
    return;
  }
  try {
    await navigator.clipboard.writeText(url);
    showToast('Link copied');
  } catch {
    showToast("Couldn't copy the link");
  }
}
